import React, { useState, useEffect, useContext } from 'react';
import { Tree, Select, Row, Col, Checkbox, Space, Button, Typography, List } from 'antd';
import { getGoodsSpecListByGoodsId, getGoodsListEnabledByCategoryId } from '../../services/Goods';
import { MasterContext } from '../../App';
import './style';
import { CheckOutlined, CloseOutlined, LeftOutlined, DoubleLeftOutlined, DoubleRightOutlined, RightOutlined } from '@ant-design/icons';
import { compare } from '../../utils/Array';

export default React.forwardRef((props, ref) => {
  const { onOk, filteredGoods } = props;
  const { goods_category } = useContext(MasterContext);
  const [selectedCategoryId, setSelectedCategoryId] = useState(undefined);
  const [selectedGoodsId, setSelectedGoodsId] = useState(undefined);
  const [goods, setGoods] = useState([]);
  const [goodsSpec, setGoodsSpec] = useState([]);
  const [selectedGoods, setSelectedGoods] = useState([]);
  const [selectedGoodsChecked, setSelectedGoodsChecked] = useState([]);
  useEffect(() => {
    if (!selectedCategoryId) return;
    getGoodsListEnabledByCategoryId(selectedCategoryId).then(data => {
      setGoods(data.sort((a, b) => compare(a, b, 'prefix')) || []);
      setSelectedGoodsId(undefined);
    });
  }, [selectedCategoryId]);

  useEffect(() => {
    if (!selectedGoodsId) return;
    getGoodsSpecListByGoodsId(selectedGoodsId).then(data => {
      setGoodsSpec(data.sort((a, b) => compare(a, b, 'name')) || []);
    });
  }, [selectedGoodsId]);

  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);

  const onExpand = (expandedKeys) => {
    console.log('onExpand', expandedKeys);
    setExpandedKeys(expandedKeys);
    setAutoExpandParent(false);
  };

  const onAdd = () => {
    let temp = [].concat(selectedGoods);
    checkedKeys.map(item => (temp.push(
      {
        goods_id: selectedGoodsId,
        goods_name: goods.find(x => x.id === selectedGoodsId).name_en,
        goods_spec_id: item,
        goods_spec_name: goodsSpec.find(x => x.id === item).name,
        size: goodsSpec.find(x => x.id === item).size,
        weight: goodsSpec.find(x => x.id === item).weight,
        surface: goodsSpec.find(x => x.id === item).surface,
      }
    )));
    setSelectedGoods(temp);
    setCheckedKeys([]);
  }
  const onDelete = () => {
    const temp = selectedGoods.filter(x => selectedGoodsChecked.indexOf(x.goods_spec_id) < 0);
    setSelectedGoods(temp);
    setSelectedGoodsChecked([]);
  }
  const onCheck = (checkedKeys) => {
    setCheckedKeys(checkedKeys);
  };

  const onSelect = (selectedKeys, info) => {
    setSelectedKeys(selectedKeys);
  };


  const onButtonOk = () => {
    if (onOk) {
      onOk(selectedGoods);
    }
  }

  const onChangeCheck = (e, value) => {
    const temp = [].concat(selectedGoodsChecked);
    const idx = temp.indexOf(value);
    if (e.target.checked) {
      if (idx < 0) {
        temp.push(value)
      }
    } else {
      if (idx >= 0) {
        temp.splice(idx, 1);
      }
    }
    setSelectedGoodsChecked(temp);
  }

  const onChangeAll = (e) => {
    if (e.target.checked) {
      const temp = goodsSpec.filter(x => !(filteredGoods || []).find(y => y.goods_spec_id === x.id) && !selectedGoods.find(y => y.goods_spec_id === x.id))
        .map(item => (item.id));
      setSelectedKeys(temp);
      setCheckedKeys(temp);
    } else {
      setSelectedKeys([]);
      setCheckedKeys([])
    }
  }
  return (
    <div style={{ padding: '1rem 1rem' }} >
      <Row gutter={[24, 24]}>
        <Col span={11}>
          <Row>
            <Select
              showSearch="true"
              optionFilterProp="children"
              placeholder="请选择报关品名"
              onChange={setSelectedCategoryId}
              style={{ width: '50%' }}
            >
              {goods_category.map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
            <Select
              showSearch="true"
              optionFilterProp="children"
              placeholder="请选择产品名称"
              onChange={setSelectedGoodsId}
              value={selectedGoodsId}
              style={{ width: '50%' }}
            >
              {goods.map(item => (
                <Select.Option key={item.id} value={item.id}>
                  [{item.prefix}] - {item.name_en} - {item.name_cn}
                </Select.Option>
              ))}
            </Select>
          </Row>
          {goodsSpec.filter(x => !(filteredGoods || []).find(y => y.goods_spec_id === x.id) && !selectedGoods.find(y => y.goods_spec_id === x.id)).length > 0 &&
            <Checkbox
              checked={goodsSpec.filter(x => !(filteredGoods || []).find(y => y.goods_spec_id === x.id) && !selectedGoods.find(y => y.goods_spec_id === x.id)).length === checkedKeys.length}
              style={{ padding: '1rem 0 0 3.125rem' }}
              onChange={onChangeAll}>全选</Checkbox>
          }
          <Tree
            style={{ margin: '1rem 0', padding: '1rem', border: '1px solid #f0f0f0' }}
            checkable
            onExpand={onExpand}
            expandedKeys={expandedKeys}
            autoExpandParent={autoExpandParent}
            onCheck={onCheck}
            checkedKeys={checkedKeys}
            onSelect={onSelect}
            selectedKeys={selectedKeys}
            value={selectedKeys}
            treeData={
              goodsSpec.filter(x => !selectedGoods.find(y => y.goods_spec_id === x.id))
                .map(item => ({
                  title: (filteredGoods || []).find(z => z.goods_spec_id === item.id) ? item.name + ' [已关联]' : item.name,
                  disableCheckbox: (filteredGoods || []).find(z => z.goods_spec_id === item.id),
                  key: item.id,
                  value: item.id
                }))}
          />
        </Col>
        <Col span={2}>
          <div style={{ margin: '0 1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <div>
              <div><Button disabled={checkedKeys.length === 0} onClick={onAdd} type="primary" icon={<RightOutlined />}>添加</Button></div>
              <br />
              <div><Button disabled={selectedGoodsChecked.length === 0} onClick={onDelete} type="primary" icon={<LeftOutlined />}>删除</Button></div>
            </div>
          </div>
        </Col>
        <Col span={11}>
          <div>
            <List style={{ width: '100%' }}
              header={<div>已选择的产品列表</div>}
              footer={<div>共{selectedGoods.length}项</div>}
              bordered
              dataSource={selectedGoods}
              renderItem={item => (
                <List.Item>
                  <Checkbox
                    checked={selectedGoodsChecked.indexOf(item.goods_spec_id) >= 0}
                    onChange={(e) => onChangeCheck(e, item.goods_spec_id)}
                    style={{ paddingRight: '1rem' }}
                  />
                  <Typography.Text mark>[{item.goods_spec_id}]</Typography.Text> {item.goods_spec_name}
                </List.Item>
              )} />
          </div>

        </Col>

      </Row>
      <Row justify="end">
        <Space size="large">
          <div style={{ marginLeft: 'auto' }}></div>
          <Button onClick={null} icon={<CloseOutlined />}>关 闭</Button>
          <Button disabled={selectedGoods.length === 0} onClick={onButtonOk} type="primary" icon={<CheckOutlined />}>确 定</Button>
        </Space>
      </Row>
    </div>
  );
});
